/* eslint-disable react/style-prop-object */
import React, { useContext, useState } from "react";
import { filtrationcontext } from "../../context/Filtercontext";
import trans from "../../utils";
import Searchbar from "../Helpers/Searchbar/Searchbar";
import { InputSelect } from "../Helpers/Input/RefactoredInput";
import { useGetPOIProjectsQuery } from "../../Redux/service/POIS/POIs";

export default function TeamsHead({ setFilter, filter }) {
  const { setSearchQuery } = useContext(filtrationcontext);
  const { data: projectsData } = useGetPOIProjectsQuery();

  const [query, setQuery] = useState("");
  const handleSearch = (e) => {
    setQuery(e.target.value);
    setSearchQuery(e.target.value);
  };

  const projectOptions =
    projectsData?.data?.map((project) => ({
      label: project.name,
      value: project.id,
    })) || [];

  const selectedProjectId =
    filter?.projectId !== null && filter?.projectId !== undefined
      ? filter.projectId
      : undefined;

  return (
    <>
      <div className="bg-white p-16 d-flex align-items-baseline gap-3">
        <Searchbar
          style="search search-dark input-group"
          path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
          placeholder={trans("Search")}
          value={query}
          onChange={handleSearch}
        />

        <InputSelect
          placeholder={trans("Project")}
          options={projectOptions}
          formstyle="flex-grow-1 text-capitalize"
          value={selectedProjectId}
          onChange={(e) => {
            const projectId = e !== null && e !== undefined ? e : null;
            setFilter((prev) => {
              const newFilter = { ...prev, projectId };
              return newFilter;
            });
          }}
        />
        <InputSelect
          placeholder={trans("Status")}
          options={[
            { label: trans("All"), value: "" },
            { label: trans("Active"), value: "ACTIVE" },
            { label: trans("Inactive"), value: "INACTIVE" },
          ]}
          formstyle="flex-grow-1 text-capitalize"
          value={filter?.status ?? undefined}
          onChange={(e) => {
            const status = e !== null && e !== undefined && e !== "" ? e : null;
            setFilter((prev) => ({ ...prev, status }));
          }}
        />
      </div>
    </>
  );
}
